import { NgModule } from '@angular/core';
import { MainComponent } from './main/main.component';
import { ModalHelpComponent } from './modal-help/modal-help.component';
import { ModalAcceptComponent } from './modal-accept/modal-accept.component';
import { ModalBackComponent } from './modal-back/modal-back.component';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { ModalViewComponent } from './modal-view/modal-view.component';
import { ModalHelpInvoiceComponent } from './modal-help-invoice/modal-help-invoice.component';
import { ModalSendMailComponent } from './modal-send-mail/modal-send-mail.component';
import { ModalErrorsComponent } from './modal-errors/modal-errors.component';
import { ModalTerminosComponent } from './modal-terminos/modal-terminos.component';
import { ModalPoliticasComponent } from './modal-politicas/modal-politicas.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { MainRoutingModule } from 'src/app/modules/main/main-routing.module';

@NgModule({
  declarations: [
    MainComponent,
    ModalHelpComponent,
    ModalAcceptComponent,
    ModalConfirmComponent,
    ModalBackComponent,
    ModalViewComponent,
    ModalHelpInvoiceComponent,
    ModalSendMailComponent,
    ModalErrorsComponent,
    ModalTerminosComponent,
    ModalPoliticasComponent
  ],
  imports: [
    SharedModule,
    MainRoutingModule
  ]
})
export class MainModule { }
